import React from 'react'

import './styles'

import ExternalLink from '/components/external-link'

STRIPE_BASE_URL = "https://dashboard.stripe.com/connect/accounts/"
urlFor = (stripe_id)->
  new URL stripe_id, STRIPE_BASE_URL

export default StripeAccounts = ({ user }) ->
  return null unless user

  permissions = user.stripe_connect_permissions.filter (scp)-> not scp.currency.match /_terminal$/i
  return 'None connected' unless permissions?.length

  account = (stripe_id, currency) ->
    url = urlFor stripe_id

    <div key={stripe_id} className="grid">
      <span>{currency.toUpperCase()}:</span>
      <div className="account">
        <span
          className="title"
          title={stripe_id}
        >
          {stripe_id}
        </span>
        <ExternalLink url={url}/>
      </div>
    </div>

  <div className="StripeAccounts">
    { for p in permissions
        account p.stripe_user_id, p.currency
    }
  </div>
